import {useState, useEffect, useContext} from 'react'
import classes from './Dashboard.module.css'
import { Container, TwoColumnLayout, Row } from '../../../Shared/FlexDiv/FlexDiv'
import {Uppercase} from '../../../../Utility'
import Rating from 'react-rating'
import { isMobile } from '../../../../Constants'
import './Style.css'
import ProfileModal from '../../../TransporterClientScreen/ProfileModal/ProfileModal'
import markericon from './marker2.png';
import Modal from '../../../Shared/PopupModal/PopupModal'
import { UserApiContext } from '../../../UserDetailsContext/UserDetailsContext';
import viewLSPStyles from "./ViewLSP.module.css";

const ViewLSP = ({ details = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredDetails = details.filter(
    (item) =>
      item.transporter_name &&
      item.transporter_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={viewLSPStyles.wrapper}>
      <div className={`${viewLSPStyles.gridRow} ${viewLSPStyles.gridHeader}`}>
        <div className='text-center'>#</div>
        <div>
          {/* <span>Transporter Name</span> */}
          <input
            type="text"
            placeholder="Transporter Name"
            className={viewLSPStyles.searchInput}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div>Rating</div>
      </div>

      {filteredDetails.length > 0 ? (
        filteredDetails.map((item, index) => {
          if (!item.transporter_name.trim()) return null;
          return (
            <div className={viewLSPStyles.gridRow} key={item.transporter_id || index}>
              <div className='text-center'>{index + 1}.</div>
              <div>
                <ProfileModal
                  buttonClass="text-left p-0"
                  transporter_id={item.transporter_id}
                  transporter_name={item.transporter_name}
                  transporter_list={details}
                />
              </div>
              <div>
                <Rating
                  initialRating={item.overall_rating || 0}
                  readonly
                  emptySymbol="fa fa-star star-1"
                  fullSymbol="fa fa-star star-1-selected"
                />
              </div>
            </div>
          );
        })
      ) : (
        <div className={viewLSPStyles.noData}>No transporters match the search.</div>
      )}
    </div>
  );
};

const ViewTT = ({ details = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredDetails = details.filter((item) =>
    item?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={viewLSPStyles.wrapper}>
      <div className={`${viewLSPStyles.gridRow} ${viewLSPStyles.gridHeader}`}>
        <div className='text-center'>#</div>
        <div>
            <input
                type="text"
                placeholder="Truck type"
                className={viewLSPStyles.searchInput}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
        </div>
      </div>

      {filteredDetails.length > 0 ? (
        filteredDetails.map((item, idx) => (
          <div className={viewLSPStyles.gridRow} key={idx}>
            <div className='text-center'>{idx + 1}.</div>
            <div>{item}</div>
          </div>
        ))
      ) : (
        <div className={viewLSPStyles.noData}>No truck types match the search.</div>
      )}
    </div>
  );
};


const Dashboard = ({
    transporter_list=[] ,
    dashboard=[],
    currentSearchedLocation,
    transporter_count=0,
    // setcurrentLayer,
    currentLayer,
    inflowTransporterList,
    inflowDashboard,
    outflowTransporterList,
    outflowDashboard
}) => {

    const [transporters, setTransporters] = useState(transporter_list)
    const [dashboard_list, setdashboard_list] = useState(dashboard)
    const [transporter_list_count, settransporter_list_count] = useState(transporter_count)
    const {userDetails} = useContext(UserApiContext)

    useEffect(() => {
        if(currentLayer === 'inbound-layer'){
            setTransporters(inflowTransporterList)
            setdashboard_list(inflowDashboard)
            settransporter_list_count(inflowDashboard[0].value)
        } 
        else if(currentLayer === 'outbound-layer'){
            setTransporters(outflowTransporterList)
            setdashboard_list(outflowDashboard)
            settransporter_list_count(outflowDashboard[0].value)
        } 
        else if(currentLayer === 'all'){
            setTransporters(transporter_list)
            setdashboard_list(dashboard)
            settransporter_list_count(transporter_count)

        }
    },[currentLayer,transporter_list, inflowDashboard, outflowDashboard, transporter_count, transporter_list_count, transporters, dashboard_list])

    const getICon=(index)=>{
        switch(index){
            case 0:return "fa fa-user"
            case 1:return "fa fa-truck"
            default:return ""
        }
    }
    const [userdetails, setuserdetails] = useState({
        allowed_view_transporter: 'no',
        allowed_view_trucktype: 'no'
    })

    useEffect(() => {
        if(userDetails){
            setuserdetails(userDetails?.policy?.location_dashboard)
        }
    }, [userDetails])

    return (
        <Container >
            <Row className={`${!isMobile()?classes['justify-content-center']:classes['justify-content-space-around']}`}>
                <span className={`${classes['Mobile-Span']} ${classes['s-s']}`}>
              
              {
                  !isMobile()?
                  <img alt='icon' src={markericon} className={`${classes['s-icon']}`}/>
                  :null
              }
                    {currentSearchedLocation}
                </span>
            </Row>
           {
               !isMobile()?
                    <div className={`row ${classes['dashboard-cards-row']}`}>
                        {dashboard_list.map((item,index)=>
                            <>
                                {userdetails?.allowed_view_transporter === 'yes' && userdetails?.allowed_view_trucktype === "yes" ? 
                                    index === 0 ?
                                    <Modal
                                        buttonLabel={
                                            <div className="d-flex flex-column">
                                                <div
                                                  className="d-flex justify-content-around align-items-center px-5"
                                                  style={{ fontSize: "30px" }}
                                                >
                                                    <i className={`${getICon(index)}`} />
                                                    <span className="">{item.value}</span>
                                                </div>
                                                <span>{item.label}</span>
                                            </div>
                                        }
                                        showLogo={true}
                                        buttonClass="btn btn-sm col-5 mx-auto my-auto DashboardCard"
                                        content={<ViewLSP details={item.box_details} index={index} />}
                                        title={`Showing ${item.value} Transporters for ${currentSearchedLocation}`}
                                        id="closebutton"
                                        screenName="Location Dashboard"
                                        moduleName="Dashboard"
                                        activityName={`#No. Transporter clicked`}
                                        backdrop={false}
                                        style={{
                                            fontSize: "13px",
                                            border: "1px solid #393185",
                                            borderRadius: "20px",
                                        }}
                                    /> :
                                    <Modal
                                        buttonLabel={
                                             <div className="d-flex flex-column">
                                                <div
                                                  className="d-flex justify-content-around align-items-center px-5"
                                                  style={{ fontSize: "30px" }}
                                                >
                                                    <i className={`${getICon(index)}`} />
                                                    <span className="">{item.value}</span>
                                                </div>
                                                <span>{item.label}</span>
                                            </div>
                                        }
                                        buttonClass="btn btn-sm col-5 mx-auto my-auto DashboardCard"
                                        content={<ViewTT details={item.box_details} index={index} />}
                                        size='md'
                                        title={`Truck type available for ${currentSearchedLocation}`}
                                        id="closebutton"
                                        screenName="Location Dashboard"
                                        moduleName="Dashboard"
                                        activityName={`#No. Truck type clicked`}
                                        backdrop={false}
                                        style={{
                                            fontSize: "13px",
                                            border: "1px solid #393185",
                                            borderRadius: "20px",
                                        }}
                                    />
                                    :
                                    <div key={index} className="col-5 mx-auto my-auto DashboardCard">
                                        <div className="d-flex flex-column">
                                            <div
                                                className="d-flex justify-content-around align-items-center px-5"
                                                style={{ fontSize: "30px" }}
                                            >
                                                <i className={`${getICon(index)}`} />
                                                <span className="">{item.value}</span>
                                            </div>
                                            <span>{item.label}</span>
                                        </div>
                                    </div>
                                }
                            </>
                        )}
                    </div>:
                    dashboard_list.map((item,index)=>
                    <>
                                {userdetails?.allowed_view_transporter === 'yes' && userdetails?.allowed_view_trucktype === "yes" ? 
                                    index === 0 ?
                                    <Modal
                                        buttonLabel={
                                            <>
                                            <i
                                                className={`font-icon-dashboard ${getICon(index)}`}
                                                style={{
                                                float: "left",
                                                marginLeft: "10%",
                                                fontWeight: "bolder",
                                                marginTop: "6px",
                                                }}
                                            />
                                            <span
                                                className="dashboard-value"
                                                style={{
                                                float: "right",
                                                marginRight: "5%",
                                                fontWeight: "bolder",
                                                fontSize: "30px",
                                                }}
                                            >
                                                {item.value}
                                            </span>
                                            <br />
                                            <br />
                                            <span style={{ marginLeft: "10px", fontSize: "14px" }}>{item.label}</span>
                                            </>
                                        }
                                        buttonClass="btn btn-sm col-5 mx-auto my-2 DashboardCard"
                                        content={<ViewLSP details={item.box_details} index={index} />}
                                        title={`Transporters for ${currentSearchedLocation}`}
                                        id="closebutton"
                                        screenName="Location Dashboard"
                                        moduleName="Dashboard"
                                        activityName={`#No. Transporter clicked`}
                                        backdrop={false}
                                        style={{
                                            fontSize: "13px",
                                            border: "1px solid #393185",
                                            borderRadius: "20px",
                                        }}
                                    /> :
                                    <Modal
                                        buttonLabel={
                                            <>
                                            <i
                                                className={`font-icon-dashboard ${getICon(index)}`}
                                                style={{
                                                float: "left",
                                                marginLeft: "10%",
                                                fontWeight: "bolder",
                                                marginTop: "6px",
                                                }}
                                            />
                                            <span
                                                className="dashboard-value"
                                                style={{
                                                float: "right",
                                                marginRight: "5%",
                                                fontWeight: "bolder",
                                                fontSize: "30px",
                                                }}
                                            >
                                                {item.value}
                                            </span>
                                            <br />
                                            <br />
                                            <span style={{ marginLeft: "10px", fontSize: "14px" }}>{item.label}</span>
                                            </>
                                        }
                                        buttonClass="btn btn-sm col-5 mx-auto my-2 DashboardCard"
                                        content={<ViewTT details={item.box_details} index={index} />}
                                        title={`Truck type available for ${currentSearchedLocation}`}
                                        id="closebutton"
                                        screenName="Location Dashboard"
                                        moduleName="Dashboard"
                                        activityName={`#No. Truck type clicked`}
                                        backdrop={false}
                                        style={{
                                            fontSize: "13px",
                                            border: "1px solid #393185",
                                            borderRadius: "20px",
                                        }}
                                    />
                                    :
                                    <div key={index}>
                                        <TwoColumnLayout
                                            rowClassName={classes['Mobile-Dashboard-Row']}
                                            leftColumnClassName={classes['Mobile-Dashboard-Label']}
                                            rightColumnClassName={classes['Mobile-Dashboard-Value']}
                                            leftColumn={item.label}
                                            rightColumn={item.value}
                                            key={index}
                                        />
                                    </div>
                                }
                            </>
                    // <div key={index}>
                    //     <TwoColumnLayout
                    //         rowClassName={classes['Mobile-Dashboard-Row']}
                            // leftColumn={item.label}
                            // rightColumn={item.value}
                            // leftColumnClassName={classes['Mobile-Dashboard-Label']}
                            // rightColumnClassName={classes['Mobile-Dashboard-Value']}
                    //         key={index}
                    //     />
                    // </div>
                    ) 
           }
            <hr/>
          {
              transporters.length>0?
              <Row className={`${classes['justify-content-center']} ${classes['font-size-14']}`}>
          TRANSPORTERS FOR {Uppercase(currentSearchedLocation)}

              </Row>:
          null
          }
          {
            // <div data-tut="view-tranporters" style={{height:'47vh', overflowY:'auto', padding: '1%'}}>
            //     {transporters.map((item, index)=>
            //         <TwoColumnLayout
            //             key={index}
            //             rowClassName={classes['Transporter_Row']}
            //             leftColumnClassName={classes['flex-basis-70']}
            //             rightColumnClassName={classes['flex-basis-30']}
            //             leftColumn={
            //                 // <a className={`${classes['s-tname']}`} href={`/tpmp/${encryptor(item.transporter_id, true)}`} target="_blank" rel="noopener noreferrer">
            //                 //     {Uppercase(item.transporter_name)}
            //                 // </a>
            //                 <ProfileModal
            //                 buttonClass={`btn-link ${classes['profilebutton']}`}
            //                     // showDetails={true}
            //                     transporter_id={item.transporter_id}
            //                     transporter_name={item.transporter_name}
            //                 />
            //                 }
            //             rightColumn={
            //                 <Rating 
            //                     initialRating={item.overall_rating?item.overall_rating:0} readonly={true} emptySymbol="fa fa-star star-1"
            //                     fullSymbol="fa fa-star star-1-selected"
            //                 />
            //             }
            //         />
            //     )}
            // </div>

            <div style={{ height: '47vh', overflowY: 'auto', padding: '1%' }}>
                {transporters.map((item, index) => {
                    const trimmedName = item.transporter_name.trim();
                    if (trimmedName !== '') {
                        return (
                            <TwoColumnLayout
                                key={index}
                                rowClassName={classes['Transporter_Row']}
                                leftColumnClassName={classes['flex-basis-70']}
                                rightColumnClassName={classes['flex-basis-30']}
                                leftColumn={
                                    <ProfileModal
                                        transporter_id={item.transporter_id}
                                        transporter_name={item.transporter_name}
                                        buttonClass={`text-left p-0`}
                                        transporter_list={transporters}
                                    />
                                }
                                rightColumn={
                                    <Rating
                                        initialRating={item.overall_rating?item.overall_rating:0} readonly={true} emptySymbol="fa fa-star star-1"
                                        fullSymbol="fa fa-star star-1-selected"
                                    />
                                }
                            />
                        );
                    }
                })}
            </div>
          }
            <Row className={`${classes['justify-content-center']} font-size-14`}>
                showing  {transporters.length} of  {transporter_list_count} Transporters
          </Row>
          <Row className={`${classes['justify-content-center']} font-size-14`}>        
          Want to view more? Email to&nbsp;<a href="mailto:connect@logisticsnow.in">connect@logisticsnow.in</a>      
          </Row>
        </Container>
    )
}

Dashboard.propTypes = {

}

export default Dashboard
